export enum OrganizationGroupRelationStatus {
  REQUESTED = 0,
  ACCEPTED = 1,
  AWAITED = 2,
  DEACTIVATION_REQUESTED = 3,
}
